import { createSingleEntityStore } from '@core/ngrx-legacy';
import type { TellentFeatureDiscoveryFeatures } from '@core/tellent-types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<TellentFeatureDiscoveryFeatures | null>()('tellent-feature-discovery');

const { update, updateSuccess, updateFailed } = actions;
const TellentFeatureDiscoveryActions = { update, updateSuccess, updateFailed };

export {
  TellentFeatureDiscoveryActions,
  selectors as TellentFeatureDiscoverySelectors,
  reducer as TellentFeatureDiscoveryReducer,
  namespace as TellentFeatureDiscoveryNamespace,
};
